import { render } from "./Sport.vue?vue&type=template&id=3678e496&scoped=true"
import script from "./Sport.vue?vue&type=script&lang=js"
export * from "./Sport.vue?vue&type=script&lang=js"

import "./Sport.vue?vue&type=style&index=0&id=3678e496&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3678e496"]])

export default __exports__